import _ from 'lodash';
import Pusher from 'pusher-js';
import React from 'react';

import { requestGet, requestPut, } from '../../../modules/request';
import PremiumConfirmationModal from '../components/subscriptions/PremiumConfirmationModal';
import SubscriptionStatus from '../components/subscriptions/SubscriptionStatus';
import AvailableCredits from '../components/subscriptions/available_credits';
import { ACCOUNT_TYPE_TO_SUBSCRIPTION_TYPES } from '../components/subscriptions/constants';
import CurrentSubscription from '../components/subscriptions/current_subscription.tsx';
import PlanExpiresCard from '../components/subscriptions/plan_expires_card.tsx';
import PremiumCreditsTable from '../components/subscriptions/premium_credits_table';
import RefundPolicy from '../components/subscriptions/refund_policy';
import SubscriptionHistory from '../components/subscriptions/subscription_history';
import { getPageTitle } from '../../Shared';

export default class Subscriptions extends React.Component {
  constructor(props) {
    super(props);
    const availableAndEarnedCredits = this.availableAndEarnedCredits(props.premiumCredits);

    this.state = {
      subscriptions: props.subscriptions,
      subscriptionStatus: props.subscriptionStatus,
      availableCredits: availableAndEarnedCredits.available,
      earnedCredits: availableAndEarnedCredits.earned,
      showPremiumConfirmationModal: false,
      authorityLevel: props.userAuthorityLevel,
      currentUserEmail: props.currentUserEmail
    };
    document.title = getPageTitle("Home", "My Subscriptions")
  }

  componentDidMount() {
    this.retrieveStripePurchasedConfirmation()
    this.retrieveStripeSubscriptionPaymentMethodUpdating()
  }

  availableAndEarnedCredits(premiumCredits) {
    let earned = 0;
    let spent = 0;

    premiumCredits.forEach((c) => {
      if (c.amount > 0) {
        earned += c.amount;
      } else {
        spent -= c.amount;
      }
    });
    return { earned, available: earned - spent, };
  }

  currentSubscription(newSub) {
    const { subscriptionStatus, } = this.state

    if (!subscriptionStatus || subscriptionStatus.expired) { return newSub }

    return subscriptionStatus;
  }

  retrieveStripePurchasedConfirmation = () => {
    const { stripeInvoiceId } = this.props

    if (!stripeInvoiceId) { return }

    requestGet(`/subscriptions/retrieve_stripe_subscription/${stripeInvoiceId}`, (body) => {
      if (body.quill_retrieval_processing) {
        this.initializePusherForStripePurchaseConfirmation()
      } else {
        this.updateSubscriptionStatus(body)
      }
    })
  }

  retrieveStripeSubscriptionPaymentMethodUpdating = () => {
    const { stripeInvoiceId, stripePaymentMethodUpdated } = this.props

    if (!stripeInvoiceId || !stripePaymentMethodUpdated) { return }

    requestGet(`/subscriptions/retrieve_stripe_subscription/${stripeInvoiceId}`, (body) => {
      if (body.quill_retrieval_processing) {
        this.initializePusherForStripeSubscriptionPaymentMethodUpdating()
      } else {
        this.updateSubscriptionStatus(body)
      }
    })
  }

  initializePusherForStripePurchaseConfirmation() {
    const { stripeInvoiceId } = this.props
    const pusher = new Pusher(window.postbuildEnv.PUSHER_KEY, { cluster: window.postbuildEnv.PUSHER_CLUSTER });
    const channelName = String(stripeInvoiceId)
    const channel = pusher.subscribe(channelName);

    channel.bind('stripe-subscription-created', () => {
      this.retrieveStripePurchasedConfirmation()
      pusher.unsubscribe(channelName)
    })
  }

  initializePusherForStripeSubscriptionPaymentMethodUpdating() {
    const { subscriptionStatus } = this.props
    const { stripe_subscription_id } = subscriptionStatus

    const pusher = new Pusher(window.postbuildEnv.PUSHER_KEY, { cluster: window.postbuildEnv.PUSHER_CLUSTER });
    const channelName = String(stripe_subscription_id)
    const channel = pusher.subscribe(channelName);

    channel.bind('stripe-subscription-payment-method-updated', () => {
      this.retrieveStripeSubscriptionPaymentMethodUpdating()
      pusher.unsubscribe(channelName)
    })
  }

  hidePremiumConfirmationModal = () => {
    this.setState({ showPremiumConfirmationModal: false, });
  };

  purchaserNameOrEmail() {
    const { subscriptionStatus, } = this.state

    if (!subscriptionStatus) { return }

    return subscriptionStatus.purchaser_name || subscriptionStatus.purchaser_email
  }

  redeemPremiumCredits = () => {
    const { subscriptions, } = this.state

    requestPut(
      `${window.postbuildEnv.DEFAULT_URL}/credit_transactions/redeem_credits_for_premium`,
      null,
      (body) => {
        this.setState({
          subscriptions: [body.subscription].concat(subscriptions),
          subscriptionStatus: this.currentSubscription(body.subscription),
          availableCredits: 0,
          showPremiumConfirmationModal: true,
        });
      },
      (body) => {
        alert(body.error);
      }
    )
  };

  showPremiumConfirmationModal = () => {
    this.setState({ showPremiumConfirmationModal: true, });
  };

  subscriptionType() {
    const { subscriptionStatus } = this.props

    if (!subscriptionStatus) { return 'Basic' }

    return ACCOUNT_TYPE_TO_SUBSCRIPTION_TYPES[subscriptionStatus.account_type]
  }

  updateSubscription = (params, subscriptionId, callback) => {
    requestPut(
      `${window.postbuildEnv.DEFAULT_URL}/subscriptions/${subscriptionId}`,
      { subscription: params, },
      (body) => {
        this.getSubscriptionData(callback)
      },
      (body) => {
        alert('There was an error updating your subscription. Please try again or contact hello@quill.org.');
      }
    )
  };

  getSubscriptionData(callback) {
    requestGet('/subscriptions', (body) => {
      const availableAndEarnedCredits = this.availableAndEarnedCredits(body.premium_credits);

      this.setState({
        subscriptions: body.subscriptions,
        subscriptionStatus: body.subscription_status,
        availableCredits: availableAndEarnedCredits.available,
        earnedCredits: availableAndEarnedCredits.earned,
        authorityLevel: body.user_authority_level,
      }, () => {
        callback ? callback() : null
      });
    })
  }

  updateSubscriptionStatus = subscription => {
    this.setState({
      showPremiumConfirmationModal: true,
      subscriptionStatus: subscription
    })
  }

  userIsContact() {
    const { authorityLevel, } = this.state
    return authorityLevel === 'purchaser' || !this.purchaserNameOrEmail()
  }

  render() {
    const { premiumCredits } = this.props

    const {
      authorityLevel,
      availableCredits,
      earnedCredits,
      showPremiumConfirmationModal,
      subscriptions,
      subscriptionStatus,
      currentUserEmail,
    } = this.state

    const userHasValidSub = subscriptionStatus && !subscriptionStatus.expired;
    const subId = `${_.get(subscriptionStatus, 'id')}-subscription-status-id`;

    return (
      <main className="subscriptions-page">
        <div className="subscriptions-top-row">
          <div className="subscriptions-top-row-left">
            <SubscriptionStatus
              customerEmail={currentUserEmail}
              key={subId}
              subscriptionStatus={subscriptionStatus}
              subscriptionType={this.subscriptionType()}
              userIsContact={this.userIsContact()}
            />
            <PlanExpiresCard
              authorityLevel={authorityLevel}
              subscriptionStatus={subscriptionStatus}
              subscriptionType={this.subscriptionType()}
            />
          </div>
          <div className="subscriptions-top-row-right">
            <CurrentSubscription
              authorityLevel={authorityLevel}
              purchaserNameOrEmail={this.purchaserNameOrEmail()}
              subscriptions={subscriptions}
              subscriptionStatus={subscriptionStatus}
              subscriptionType={this.subscriptionType()}
              updateSubscription={this.updateSubscription}
              userIsContact={this.userIsContact()}
            />
          </div>
        </div>
        <AvailableCredits
          availableCredits={availableCredits}
          redeemPremiumCredits={this.redeemPremiumCredits}
          subscriptionType={this.subscriptionType()}
          userHasValidSub={userHasValidSub}
        />
        <SubscriptionHistory
          authorityLevel={authorityLevel}
          premiumCredits={premiumCredits}
          subscriptions={subscriptions}
        />
        <PremiumCreditsTable
          earnedCredits={earnedCredits}
          premiumCredits={premiumCredits}
        />
        <RefundPolicy />
        <PremiumConfirmationModal
          hideModal={this.hidePremiumConfirmationModal}
          show={showPremiumConfirmationModal}
          subscription={subscriptionStatus}
        />
      </main>
    )
  }
}
